"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const helpers_1 = require("../../helpers");
const IconSuccess_1 = __importDefault(require("../../assets/icons/IconSuccess"));
const IconAddPost_1 = __importDefault(require("../../assets/icons/IconAddPost"));
const AppContextProvider_1 = require("../../contexts/AppContextProvider");
const addPost_1 = require("../../helpers/links-builders/addPost");
const useTrackPageView_1 = __importDefault(require("../../GTMs/useTrackPageView"));
const slrActions_1 = require("../../GTMs/actions/slrActions");
const constants_1 = require("../../constants");
const loggingActions_1 = require("../../libs/logging/helpers/loggingActions");
const helpersMethod_1 = require("../../libs/logging/helpers/helpersMethod");
const SuccessScreen = ({ setIsSsoModalOpen }) => {
    var _a, _b;
    const { translations, isDesktop, fullPage, redirectUrl } = (0, styled_components_1.useTheme)();
    console.log("redirectUrl", redirectUrl);
    const { flowState } = (0, AppContextProvider_1.useSsoContext)();
    (0, useTrackPageView_1.default)("slrSuccessScreen", true, true);
    (0, react_1.useEffect)(() => {
        document.dispatchEvent(new CustomEvent(constants_1.LOGIN_SUCCESS_CONSTANT));
        successDialogScreenLoadLogging();
    }, []);
    const onContinueCallBack = () => {
        window[constants_1.ON_CONTINUE_CB] && window[constants_1.ON_CONTINUE_CB]();
        if (fullPage && redirectUrl) {
            window.location.href = redirectUrl;
            return;
        }
        setIsSsoModalOpen(false);
    };
    const successDialogScreenLoadLogging = () => {
        var _a;
        const prevScreen = (0, helpers_1.getPrevScreen)(flowState.screensFlow, flowState.screenType);
        switch (prevScreen) {
            case constants_1.ScreenConstants.RETURNING_USER:
            case constants_1.ScreenConstants.NEW_USER:
            case constants_1.ScreenConstants.REGISTER_NEW_USER:
            case constants_1.ScreenConstants.NEW_PASSWORD:
                const currentScreenLoggingScreenName = (0, loggingActions_1.getSuccessDialogLoggingScreenName)(prevScreen);
                (0, helpersMethod_1.loadScreenAction)({
                    currentScreen: currentScreenLoggingScreenName.screenName,
                    memberId: (_a = flowState === null || flowState === void 0 ? void 0 : flowState.memberData) === null || _a === void 0 ? void 0 : _a.id,
                });
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "successScreen" }, (0, helpers_1.classNames)("grayBg p-16", isDesktop && "width-460 border radius-8 overflowHidden"), { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "flex p-16 whiteBg radius-8 fullShadow gap-10" }, { children: [(0, jsx_runtime_1.jsx)(IconSuccess_1.default, {}), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("strong", { children: (_a = flowState === null || flowState === void 0 ? void 0 : flowState.successScreen) === null || _a === void 0 ? void 0 : _a.title }), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "font-14 mt-8" }, { children: (_b = flowState === null || flowState === void 0 ? void 0 : flowState.successScreen) === null || _b === void 0 ? void 0 : _b.description }))] })] })), (0, jsx_runtime_1.jsx)("button", Object.assign({ className: "blueBtn block p-20 mt-16 font-17", onClick: () => {
                    onContinueCallBack();
                    (0, slrActions_1.gtmContinueBtn_SLRSuccessScreen)();
                } }, { children: translations.continue })), flowState.successScreen.withAddPost && ((0, jsx_runtime_1.jsxs)("button", Object.assign({ className: "orangeBtn flex alignItems gap-10 justifyContent p-20 mt-16 font-17", onClick: () => {
                    var _a;
                    const prevScreen = (0, helpers_1.getPrevScreen)(flowState.screensFlow, flowState.screenType);
                    const currentScreen = (0, loggingActions_1.getSuccessDialogLoggingScreenName)(prevScreen);
                    (0, loggingActions_1.addListingClickAction)({ currentScreen: currentScreen.screenName, memberId: (_a = flowState === null || flowState === void 0 ? void 0 : flowState.memberData) === null || _a === void 0 ? void 0 : _a.id });
                    (0, slrActions_1.gtmAddPostBtn_SLRSuccessScreen)();
                    window.location.href = (0, addPost_1.linkToAddPost)();
                } }, { children: [(0, jsx_runtime_1.jsx)(IconAddPost_1.default, {}), translations.addListing] })))] })));
};
exports.default = SuccessScreen;
